import {ActionReducerMapBuilder, createReducer, PayloadActionCreator} from 'util/redux';
import {keyBy} from 'lodash';

type IdType = number | string

interface Args<T extends { [key in string]: any }, ID extends IdType> {
	resetAction: PayloadActionCreator<T[]>
	addAction?: PayloadActionCreator<T>
	idProp: string
	byIdBuilder?: (builder: ActionReducerMapBuilder<{ [id in IdType]: T }>) => ActionReducerMapBuilder<{ [id in IdType]: T }>
	allIdsBuilder?: (builder: ActionReducerMapBuilder<ID[]>) => ActionReducerMapBuilder<ID[]>
}

export function createReducerNormalized<T extends { [key: string]: any }, ID extends IdType>({idProp, resetAction, addAction, byIdBuilder, allIdsBuilder}: Args<T, ID>) {
	const byId = createReducer<{ [id in IdType]: T }>({}, builder => {
			builder = builder.addCase(resetAction, (state, {payload}) => keyBy(payload, idProp))
			if (addAction) {
				builder = builder.addCase(addAction, (state, {payload}) => {
					if (!payload) return state
					const id = payload[idProp] as ID
					return {
						...state,
						[id]: payload as T,
					} as { [id in IdType]: T }
				})
			}
			return byIdBuilder?.(builder) ?? builder
		},
	)
	const allIds = createReducer<ID[]>([], builder => {
			builder = builder.addCase(resetAction, (state, {payload}) => payload.map((x: T) => x[idProp] as ID))
			if (addAction) {
				builder = builder.addCase(addAction, (state, {payload}) => !payload || state.includes(payload[payload[idProp]]) ? state : state.concat(payload[idProp]))
			}
			return allIdsBuilder?.(builder) ?? builder
		},
	)
	return {byId, allIds}
}